import React from 'react';
import ArticlesStats from './ArticlesStats';
import ArticleStatsTable from './ArticleStatsTable';
import styles from './Dashboard.module.css';
import TableHeader from './TableHeader';

const Dashboard = () => (
  <div className={styles.dashboard}>
    <ArticlesStats />
    <TableHeader />
    <ArticleStatsTable />
  </div>
);

export default Dashboard;
